class ChatTrigger {
  constructor() {

    const chatTriggers = document.querySelectorAll('.wc-webchat');

    window.setTimeout(function () {
      chatTriggers.forEach((item) => {
        item.classList.add('wc-show')
      });
    }, 5000);

    document.querySelectorAll('.popup-launcher').forEach(item => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        window.open(item.getAttribute('href'), 'newwindow', 'width=' + item.getAttribute('data-target-width') + ', height=' + item.getAttribute('data-target-height')); return false;
      })
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ChatTrigger();
})
